import { useCallback } from "react";
import type { ConnectProto } from "@racoon/api";
import { useLazyGetContractQuery } from "~/shared/api/contract/contract.grpc";
import { useSelectedCompany } from "~/shared/store/company/hooks/useSelectedCompany";
import { useContractEditModal } from "./use-contract-edit-modal";

/**
 * Opens a contract's card from an embedded copy of it. Embedded contracts are partial
 * (no files), so the card gets a fresh copy; `ownerId` stands in for a missing target
 * organization (a container group's owner).
 */
export const useOpenContract = () => {
  const { selectedCompanyId } = useSelectedCompany();
  const { openEdit } = useContractEditModal();
  const [getContract] = useLazyGetContractQuery();
  return useCallback(
    async (contract: ConnectProto.Contract, ownerId?: bigint) => {
      const { data } = await getContract({
        id: contract.id,
        serviceProviderId: contract.serviceProviderId || BigInt(selectedCompanyId ?? 0),
        targetOrganizationId: contract.targetOrganizationId || (ownerId ?? 0n),
      });
      if (data) openEdit(data);
    },
    [getContract, openEdit, selectedCompanyId],
  );
};
